import moment from 'moment';

/**
 * Fleet / Route / Trip TMS (feature 001-fleet-route-trips) — shared helpers.
 * Backend base path: /api/v1/fleet/... (normalAxios = this.$http, bearer auth
 * like every other admin call). Known 422 error codes are mapped to Lao text.
 */

export const FLEET_BASE = 'v1/fleet';

// Known backend error codes -> Lao messages (fleet-api.md "Error codes").
export const FLEET_ERROR_MESSAGES = {
    ROUND_EXISTS: 'ຮອບນີ້ມີຢູ່ແລ້ວ ສຳລັບເສັ້ນທາງ ແລະ ວັນທີດັ່ງກ່າວ',
    TRUCK_HAS_TRIPS: 'ລົດຄັນນີ້ມີຖ້ຽວແລ່ນຢູ່ ບໍ່ສາມາດລຶບໄດ້ (ແນະນຳໃຫ້ປິດການໃຊ້ງານແທນ)',
    ROUTE_HAS_NO_STOPS: 'ເສັ້ນທາງຍັງບໍ່ມີຈຸດແວະ ບໍ່ສາມາດເປີດໃຊ້ງານໄດ້',
    ROUTE_HAS_NO_START: 'ເສັ້ນທາງຍັງບໍ່ມີຈຸດເລີ່ມຕົ້ນ ບໍ່ສາມາດເປີດໃຊ້ງານໄດ້',
    ROUTE_NOT_ACTIVE: 'ເສັ້ນທາງນີ້ຍັງບໍ່ໄດ້ເປີດໃຊ້ງານ',
    TRIP_NOT_OPEN: 'ຖ້ຽວນີ້ບໍ່ຢູ່ໃນສະຖານະເປີດ (ປິດ ຫຼື ຍົກເລີກແລ້ວ)',
    TRIP_HAS_PARCELS_ON_TRUCK: 'ຍັງມີພັດສະດຸຢູ່ເທິງລົດ — ຕ້ອງເອົາລົງໃຫ້ໝົດກ່ອນປິດຖ້ຽວ (ຫຼື ໃຫ້ຜູ້ຈັດການບັງຄັບປິດ)',
    TRIP_NOT_PLANNED: 'ແກ້ໄຂໄດ້ສະເພາະຖ້ຽວທີ່ຍັງຢູ່ໃນສະຖານະວາງແຜນ',
    TRIP_NOT_CLOSED: 'ຖ້ຽວນີ້ຍັງບໍ່ໄດ້ປິດ ບໍ່ສາມາດເປີດຄືນໄດ້',
    TRIP_NOT_APPROVED: 'ຖ້ຽວນີ້ຍັງບໍ່ໄດ້ຮັບການອະນຸມັດ',
    // TMS usability round (route QR / optional truck / truck upload).
    TRIP_TRUCK_REQUIRED: 'ຖ້ຽວນີ້ຍັງບໍ່ມີລົດ — ກະລຸນາເລືອກລົດກ່ອນເລີ່ມຖ້ຽວ',
    IMPORT_IN_PROGRESS: 'ມີການອັບໂຫຼດຂໍ້ມູນລົດຢູ່ແລ້ວ — ກະລຸນາລໍຖ້າແລ້ວລອງໃໝ່',
    TEMPLATE_INVALID: 'ໄຟລ໌ບໍ່ຖືກແບບຟອມ — ກະລຸນາດາວໂຫຼດແບບຟອມໃໝ່',
    SAME_DATE: 'ວັນທີຕົ້ນສະບັບ ແລະ ປາຍທາງ ຕ້ອງບໍ່ຊ້ຳກັນ',
    TRIP_STOP_NOT_ON_TRIP: 'ຈຸດແວະນີ້ບໍ່ຢູ່ໃນຖ້ຽວດັ່ງກ່າວ',
    DRIVER_NOT_ON_TRIP: 'ຄົນຂັບບໍ່ຢູ່ໃນຖ້ຽວນີ້',
    DRIVER_ALREADY_ON_TRIP: 'ຄົນຂັບຢູ່ໃນຖ້ຽວນີ້ແລ້ວ',
    TRUCK_ALREADY_ASSIGNED: 'ລົດຄັນນີ້ຖືກມອບໝາຍໃສ່ຖ້ຽວອື່ນແລ້ວໃນມື້ດຽວກັນ',
    DRIVER_ALREADY_ASSIGNED: 'ຄົນຂັບຖືກມອບໝາຍໃສ່ຖ້ຽວອື່ນແລ້ວໃນມື້ດຽວກັນ',
    SAME_TRIP: 'ຖ້ຽວປາຍທາງຕ້ອງບໍ່ແມ່ນຖ້ຽວດຽວກັນ',
    ODOMETER_BACKWARD: 'ເລກໄມລ໌ສິ້ນສຸດນ້ອຍກວ່າເລກໄມລ໌ເລີ່ມຕົ້ນ',
    FUEL_EXCEEDS_STANDARD: 'ນ້ຳມັນເກີນມາດຕະຖານຂອງເສັ້ນທາງ (ໃຫ້ການເງິນກວດຄືນ)',
    FORCE_CLOSED_WITH_PARCELS: 'ບັງຄັບປິດຖ້ຽວ ທັ້ງທີ່ຍັງມີພັດສະດຸຢູ່ເທິງລົດ',
    // GPS distance cross-check (001-fleet-gps-tracking, US4) — finance review flags.
    GPS_OVER_ODOMETER: 'GPS ໄກກວ່າເລກໄມລ໌ (ອາດເລກໄມລ໌ຕໍ່າກວ່າຄວາມຈິງ — ໃຫ້ການເງິນກວດຄືນ)',
    GPS_UNDER_ODOMETER: 'GPS ໃກ້ກວ່າເລກໄມລ໌ (ອາດເລກໄມລ໌ສູງກວ່າຄວາມຈິງ — ໃຫ້ການເງິນກວດຄືນ)',
    GPS_OVER_PLANNED: 'GPS ໄກກວ່າແຜນ (ອາດແລ່ນນອກເສັ້ນທາງ — ໃຫ້ກວດຄືນ)',
    GPS_UNDER_PLANNED: 'GPS ໃກ້ກວ່າແຜນ (ອາດແລ່ນບໍ່ຄົບເສັ້ນທາງ — ໃຫ້ກວດຄືນ)',
    OFF_ROUTE_CONFIRM_REQUIRED: 'ພັດສະດຸບໍ່ຢູ່ໃນເສັ້ນທາງ ຕ້ອງຢືນຢັນກ່ອນ',
    // A stop only accepts an unload once the truck has actually been there,
    // and never at the origin (parcels are LOADED there, not dropped).
    FLEET_STOP_NOT_VISITED: 'ຍັງບໍ່ໄດ້ເຊັກອິນຈຸດຈອດນີ້ — ຕ້ອງເຊັກອິນ (ຮອດຈຸດຈອດ) ກ່ອນຍິງເຄື່ອງລົງ',
    FLEET_STOP_IS_ORIGIN: 'ຈຸດຕົ້ນທາງ — ເປັນຈຸດໂຫຼດຂຶ້ນລົດ ບໍ່ແມ່ນຈຸດຍິງເຄື່ອງລົງ',
    INVALID_ACTION: 'ຄຳສັ່ງບໍ່ຖືກຕ້ອງ',
    RANGE_INVALID: 'ຊ່ວງວັນທີບໍ່ຖືກຕ້ອງ',
    RANGE_TOO_LARGE: 'ຊ່ວງວັນທີຍາວເກີນ 92 ວັນ',
};

/**
 * ---------------- ONE canonical presentation of a leg direction ----------------
 * Every trip-bearing surface (board, detail, live map, stop-incoming, round
 * planner, reports) must render the leg identically. Before this existed the
 * same ຂາກັບ chip appeared in teal on three pages and amber on four, with the
 * ternary copy-pasted inline five times. Import FLEET_DIRECTION / the
 * FleetDirection* helpers instead of writing a new ternary.
 */
export const FLEET_DIRECTION = {
    outbound: {label: 'ຂາໄປ', color: '#195BFF', icon: 'fal fa-truck-loading'},
    return: {label: 'ຂາກັບ', color: '#0a9', icon: 'fal fa-undo'},
};

export const fleetDirection = (direction) => (direction === 'return'
    ? FLEET_DIRECTION.return
    : FLEET_DIRECTION.outbound);

/**
 * ---------------- ONE canonical parcel-movement vocabulary ----------------
 * ຮັບ = loaded on (+, green), ລົງ = taken off (−, red), ເທິງລົດ = still aboard.
 * Colours were previously inconsistent (the live map had ລົງ amber and
 * off-route crimson, the inverse of every other surface).
 */
export const FLEET_MOVEMENT_COLORS = {
    in: '#2dcc70',      // ຮັບ
    out: '#e2445c',     // ລົງ
    onBoard: '#195BFF', // ເທິງລົດ
    offRoute: '#e8a10f', // ນອກເສັ້ນທາງ
};

/**
 * Canonical off-route text: `+N ນອກເສັ້ນທາງ (M ຢູ່ເທິງລົດ)`.
 * `onBoard` is the still-aboard SUBSET; omitted when absent/zero.
 * Returns '' when there is no off-route volume, so callers can `v-if` on it.
 */
export const fleetOffRouteText = (pieces, onBoard = null) => {
    const n = Number(pieces) || 0;
    if (!n) return '';
    const m = Number(onBoard) || 0;
    return m > 0 ? `+${n} ນອກເສັ້ນທາງ (${m} ຢູ່ເທິງລົດ)` : `+${n} ນອກເສັ້ນທາງ`;
};

export const TRIP_STATUS_LABELS = {
    planned: 'ວາງແຜນແລ້ວ',
    in_progress: 'ກຳລັງແລ່ນ',
    closed: 'ປິດຖ້ຽວແລ້ວ',
    cancelled: 'ຍົກເລີກ',
};

export const TRIP_STATUS_COLORS = {
    planned: '#195BFF',
    in_progress: '#e8a10f',
    closed: '#2dcc70',
    cancelled: 'crimson',
};

export const STOP_STATUS_LABELS = {
    pending: 'ລໍຖ້າ',
    arrived: 'ຮອດແລ້ວ',
    departed: 'ອອກແລ້ວ',
    skipped: 'ຂ້າມ',
};

/**
 * Manifest parcel statuses. Same wording as the parcel-list filter options and
 * the driver app's fleetParcelStatusLabel(); the reconciliation and drill
 * tables were printing the raw keys (`on_truck`, `wrong_stop`, …).
 */
export const PARCEL_STATUS_LABELS = {
    on_truck: 'ຢູ່ເທິງລົດ',
    delivered: 'ສົ່ງແລ້ວ',
    wrong_stop: 'ຜິດຈຸດ',
    transferred: 'ຍ້າຍໄປລົດອື່ນ',
    removed: 'ຍົກເລີກ',
};

export const SIZE_CLASS_LABELS = {
    small: 'ລົດນ້ອຍ',
    medium: 'ລົດກາງ',
    large: 'ລົດໃຫຍ່',
};

/** ---------------- Shared map bits (route builder + trip map) ---------------- */

// Base map view modes for the single cycle button (icon+label per mode).
export const FLEET_MAP_MODES = [
    {id: 'roadmap', icon: 'fal fa-map', label: 'ແຜນທີ່'},
    {id: 'satellite', icon: 'fal fa-satellite', label: 'ດາວທຽມ'},
    {id: 'hybrid', icon: 'fal fa-layer-group', label: 'ປະສົມ'},
    {id: 'terrain', icon: 'fal fa-mountain', label: 'ພູມສັນຖານ'},
];

// Self-contained SVG pin (data URI — no external image request, so it can
// never be blocked by mixed-content/https like Google-hosted marker PNGs,
// which render NO marker at all when the image fails to load).
export const fleetPinIcon = (color) => ({
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="44" viewBox="0 0 34 44">'
        + '<path d="M17 1C8.7 1 2 7.7 2 16c0 11.2 15 27 15 27s15-15.8 15-27C32 7.7 25.3 1 17 1z" '
        + `fill="${color}" stroke="white" stroke-width="2"/></svg>`,
    ),
    scaledSize: {width: 34, height: 44, f: 'px', b: 'px'},
    labelOrigin: {x: 17, y: 16},
});

// Self-contained truck marker (data URI SVG — same no-external-request
// reasoning as fleetPinIcon). Used on the live dispatch map so a moving truck
// reads as a truck, not a place pin.
//
// TOP-DOWN, not a side profile. A side view cannot be rotated to a compass
// bearing without looking like the truck has fallen over — you are looking at
// the map from above, so the truck must be drawn from above too. Drawn nose-UP
// (north), which makes the rotation the bearing itself with no offset to get
// backwards.
//
// `heading` is the compass bearing on the live position (0 = north, clockwise).
// null/absent leaves it unrotated rather than snapping to north — a stationary
// fix often reports no heading, and no heading is not a heading of 0.
//
// `plate` is drawn OUTSIDE the rotated group, so the label stays upright and
// readable while the truck turns. It sits in a white pill rather than as a
// Google marker label because a bare label has no background and disappears
// over the satellite basemap.
export const fleetTruckIcon = (color, heading = null, plate = null) => {
    const rotate = (heading === null || heading === undefined || isNaN(Number(heading)))
        ? null : Number(heading);

    // Nose at the top, tail at the bottom, pivot at (48,24). Axles are drawn
    // WIDER than the body so they read as wheels from above instead of hiding
    // under it, and the cab is set off from the trailer by a gap so the two
    // don't merge into one slab at marker size.
    const truck = '<g stroke="white" stroke-width="1.5" stroke-linejoin="round">'
        + '<rect x="36" y="20" width="24" height="7" rx="2.5" fill="#263238"/>'  // front axle
        + '<rect x="36" y="33" width="24" height="7" rx="2.5" fill="#263238"/>'  // rear axle
        + `<rect x="40" y="16.5" width="16" height="24.5" rx="2.5" fill="${color}"/>`  // trailer
        + `<rect x="41.5" y="6" width="13" height="12" rx="3" fill="${color}"/>`       // cab (overlaps 1.5)
        + '<rect x="43.5" y="8" width="9" height="4" rx="1.2" fill="white" opacity="0.92" stroke="none"/>'
        + '</g>';

    const body = rotate === null
        ? truck
        : `<g transform="rotate(${rotate.toFixed(1)} 48 24)">${truck}</g>`;

    // Only the PILL is drawn here — the plate text itself is a Google marker
    // label (see fleetTruckLabel), because a data-URI SVG used as a marker icon
    // renders in an isolated context with NO access to the page's webfonts. The
    // Lao face (BoonBaan) never loads in there, so text baked into the SVG
    // silently falls back to whatever Lao font the OS happens to ship. A marker
    // label is real DOM, so it picks up the app font like everything else.
    // The pill stays in the SVG to give that label a background — a bare label
    // is unreadable over the satellite basemap.
    let pill = '';
    if (plate !== null && plate !== undefined && String(plate).trim() !== '') {
        // Generous width: the DOM text is measured by the browser, not by us,
        // and Lao glyphs run wider than Latin. Better a little padding than a
        // plate overflowing its pill.
        const w = Math.max(48, (String(plate).trim().length * 9) + 18);
        const x = 48 - (w / 2);
        pill = `<rect x="${x.toFixed(1)}" y="47" width="${w.toFixed(1)}" height="18" rx="9"`
            + ` fill="white" stroke="${color}" stroke-width="1.4"/>`;
    }

    return {
        url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
            '<svg xmlns="http://www.w3.org/2000/svg" width="96" height="66" viewBox="0 0 96 66">'
            + body + pill + '</svg>',
        ),
        scaledSize: {width: 96, height: 66, f: 'px', b: 'px'},
        // Anchor on the truck's pivot, so the marker sits at the real position
        // and the plate hangs below it.
        anchor: {x: 48, y: 24, f: 'px', b: 'px'},
        // Where the DOM label lands: the centre of the pill drawn above.
        labelOrigin: {x: 48, y: 56, f: 'px', b: 'px'},
    };
};

// The marker label that pairs with fleetTruckIcon's pill. Kept beside it so the
// two cannot drift apart — the pill is sized for this text at this size.
// fontFamily mirrors the app's $font so Lao renders in BoonBaan rather than a
// system fallback.
export const fleetTruckLabel = (plate) => {
    const text = (plate === null || plate === undefined) ? '' : String(plate).trim();
    if (text === '') return null;

    return {
        text,
        color: '#263238',
        fontSize: '12px',
        fontWeight: 'bold',
        fontFamily: "'Open Sans', 'BoonBaan', sans-serif",
    };
};

// Small dot marker (driver check-in GPS stamps on the trip map).
export const fleetDotIcon = (color) => ({
    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">'
        + `<circle cx="9" cy="9" r="7" fill="${color}" stroke="white" stroke-width="2"/></svg>`,
    ),
    scaledSize: {width: 18, height: 18, f: 'px', b: 'px'},
});

// Road-following path between ordered stops via the Directions service
// (like Google Maps directions). Resolves null on ANY failure — e.g. the
// Directions API not enabled on the key — so callers fall back to the
// straight polyline instead of showing nothing. Chunks requests to respect
// the 25-waypoint limit on long routes.
export const fleetRoadPath = async (points) => {
    if (!window.google || !window.google.maps || !window.google.maps.DirectionsService || points.length < 2) {
        return null;
    }
    const service = new window.google.maps.DirectionsService();
    const routeChunk = (chunk) => new Promise((resolve) => {
        service.route({
            origin: chunk[0],
            destination: chunk[chunk.length - 1],
            waypoints: chunk.slice(1, -1).map((point) => ({location: point, stopover: true})),
            travelMode: 'DRIVING',
        }, (result, status) => {
            const route = status === 'OK' && result && result.routes && result.routes[0];
            if (!route) {
                resolve(null);
                return;
            }
            // Full-resolution geometry: every step's decoded path (exactly what
            // Google Maps itself draws). overview_path is only a smoothed
            // approximation — keep it as a fallback, never the first choice.
            const detailed = [];
            (route.legs || []).forEach((leg) => {
                (leg.steps || []).forEach((step) => {
                    (step.path || []).forEach((ll) => {
                        detailed.push({lat: ll.lat(), lng: ll.lng()});
                    });
                });
            });
            if (detailed.length > 1) {
                resolve(detailed);
                return;
            }
            resolve(route.overview_path
                ? route.overview_path.map((ll) => ({lat: ll.lat(), lng: ll.lng()}))
                : null);
        });
    });

    const path = [];
    // ≤26 points per request (origin + destination + 24 waypoints).
    for (let start = 0; start < points.length - 1; start += 25) {
        const chunk = points.slice(start, start + 26);
        // eslint-disable-next-line no-await-in-loop
        const legs = await routeChunk(chunk);
        if (!legs) return null; // any failed leg -> straight-line fallback
        path.push(...legs);
    }
    return path.length > 1 ? path : null;
};

export const OWNERSHIP_LABELS = {
    company: 'ລົດບໍລິສັດ',
    contractor: 'ລົດຜູ້ຮັບເໝົາ',
};

export const STOP_TYPE_LABELS = {
    branch: 'ສາຂາ',
    distribution_center: 'ສູນຄັດແຍກ',
};

/**
 * Extract every message from a Laravel 422 payload ({errors:{field:[msg,..]}}),
 * translating known fleet error codes to Lao. Returns a display string.
 */
export const extractFleetError = (error, fallback = 'ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່') => {
    const res = error && error.response;
    if (!res) return fallback;
    if (res.data && res.data.errors) {
        const messages = [];
        Object.values(res.data.errors).forEach((list) => {
            (Array.isArray(list) ? list : [list]).forEach((msg) => {
                messages.push(FLEET_ERROR_MESSAGES[msg] || msg);
            });
        });
        if (messages.length) return messages.join(' / ');
    }
    if (res.data && res.data.message) {
        return FLEET_ERROR_MESSAGES[res.data.message] || res.data.message;
    }
    return fallback;
};

/** Flatten server 422 field errors into a {field: firstMessage} object. */
export const fleetFieldErrors = (error) => {
    const out = {};
    const errors = error && error.response && error.response.data && error.response.data.errors;
    if (errors) {
        for (const [key, value] of Object.entries(errors)) {
            const msg = Array.isArray(value) ? value[0] : value;
            out[key] = FLEET_ERROR_MESSAGES[msg] || msg;
        }
    }
    return out;
};

export const conflictText = (conflict) => {
    const label = FLEET_ERROR_MESSAGES[conflict.message] || conflict.message;
    return `${label} (ຖ້ຽວ ${conflict.trip_code || conflict.trip_id})`;
};

/**
 * Manifest totals of a trip row: the backend keys `totals` BY STATUS
 * ({on_truck: {bills,pieces,weight_kg,cbm,no_dimension_count},
 * delivered_pieces, wrong_stop_pieces}) — read the on_truck block,
 * tolerating a flat legacy shape. Always returns an object.
 */
export const tripTotals = (trip) => {
    const totals = trip && trip.totals;
    return (totals && (totals.on_truck || totals)) || {};
};

/** True when an off-route volume block ({bills,pieces,weight_kg,...}) carries anything. */
export const hasOffRouteVolume = (volume) => !!volume
    && ((Number(volume.pieces) || 0) > 0
        || (Number(volume.bills) || 0) > 0
        || (Number(volume.weight_kg) || 0) > 0);

export const fleetFormatNumber = (value, digits = 0) => {
    if (value === null || value === undefined || value === '' || isNaN(value)) return '0';
    return Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
    });
};

export const fleetFormatDate = (value) => (value ? moment(String(value)).format('DD/MM/YYYY') : '...');

export const fleetFormatDateTime = (value) => (value ? moment(String(value)).format('DD/MM/YYYY HH:mm') : '...');

export const fleetFormatTime = (value) => (value ? moment(String(value)).format('HH:mm') : '...');

/**
 * EVERY row of a paginated fleet list, for pickers that search client-side.
 * The backend caps per_page at 100, so a picker that read page 1 only silently
 * lost the rest (141 active trucks on prod: 41 never appeared in ເລືອກລົດ).
 * Pages are read one after another up to the last_page the API reports.
 */
const FLEET_PICKER_PER_PAGE = 100;

export const fleetFetchAllPages = (http, url, params = {}) => {
    const rows = [];
    const fetchFrom = (page) => http.get(url, {params: {...params, per_page: FLEET_PICKER_PER_PAGE, page}})
        .then((res) => {
            rows.push(...(res.data.data || []));
            const lastPage = Number(res.data.meta && res.data.meta.last_page) || 1;
            return page < lastPage ? fetchFrom(page + 1) : rows;
        });
    return fetchFrom(1);
};

/** Save an xlsx blob response like other export buttons in the repo. */
export const saveXlsxBlob = (response, fileName) => {
    const fileUrl = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');
    fileLink.href = fileUrl;
    fileLink.setAttribute('download', fileName);
    document.body.appendChild(fileLink);
    fileLink.click();
    document.body.removeChild(fileLink);
};

/**
 * GPS integrity review flags (001-fleet-gps-tracking) — Lao labels for the
 * backend's gps_integrity.flags. These are EVIDENCE labels, never verdicts:
 * an OEM battery killer produces the same gap signature as a driver hiding
 * the app, so every label reads as "review this", not "guilty". Crimson =
 * something the OS/filter confirmed itself (mock provider, implausible
 * fixes); amber = a coverage pattern that wants a human look.
 */
export const FLEET_GPS_INTEGRITY_FLAGS = {
    // severity drives OPERATIONAL rendering (the board icon colour): a
    // 'confirmed' signal came from the OS/filter itself; 'coverage' is a
    // pattern wanting a human look. Colours are presentation only — derive
    // severity decisions from `severity`, never by comparing colour strings.
    NO_GPS_DATA: {label: 'ບໍ່ມີສັນຍານ GPS ຕະຫຼອດຖ້ຽວ (ອາດບໍ່ໄດ້ເປີດແອັບ)', color: '#e8a10f', severity: 'coverage'},
    LOW_COVERAGE: {label: 'ສັນຍານ GPS ຂາດຫາຍຫຼາຍຊ່ວງຂອງຖ້ຽວ', color: '#e8a10f', severity: 'coverage'},
    MOCKED_FIXES: {label: 'ພົບພິກັດປອມ (Fake GPS — ລະບົບມືຖືຢືນຢັນເອງ)', color: '#e21312', severity: 'confirmed'},
    HIGH_REJECT_RATE: {label: 'ພິກັດຜິດປົກກະຕິຫຼາຍຜິດສັດສ່ວນ (ຖືກລະບົບກັ່ນຕອງອອກ)', color: '#e21312', severity: 'confirmed'},
    ARRIVALS_WITHOUT_TRAVEL: {label: 'ມີສັນຍານສະເພາະຢູ່ຈຸດຈອດ ແຕ່ຫາຍລະຫວ່າງທາງ (ອາດປິດແອັບຂະນະແລ່ນ)', color: '#e21312', severity: 'confirmed'},
};

/**
 * {label, color, severity} for a gps_integrity flag code. A flag this build
 * doesn't know yet (newer backend) degrades to grey/'coverage': it still shows
 * and still raises the board icon (amber), it just doesn't claim confirmation
 * it can't vouch for.
 */
export const fleetGpsFlag = (flag) => FLEET_GPS_INTEGRITY_FLAGS[flag]
    || {label: flag, color: '#5a6472', severity: 'coverage'};

/** Non-empty flag list of a trip row / integrity block, always an array. */
export const fleetGpsFlags = (tripOrBlock) => {
    const block = tripOrBlock && (tripOrBlock.gps_integrity || tripOrBlock);
    return (block && Array.isArray(block.flags)) ? block.flags : [];
};

/** 'X ຊມ Y ນທ' from seconds (gap/window durations on the integrity card). */
export const fleetFormatDuration = (seconds) => {
    const s = Number(seconds) || 0;
    if (s < 60) return `${s} ວິ`;
    const totalMin = Math.round(s / 60);
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    if (h === 0) return `${m} ນທ`;
    return m === 0 ? `${h} ຊມ` : `${h} ຊມ ${m} ນທ`;
};

/**
 * The Laratrust permission that unlocks transport MONEY on the TMS screens:
 * ລາຄາ/ຖ້ຽວ, the fuel amounts and every unit cost derived from them.
 *
 * `distributioncentermanager` plans routes, rounds and trips and sees all of it
 * EXCEPT this. Backend counterpart: App\Support\Fleet\FleetCostVisibility —
 * SuperAdmin and service always pass there, and $canDo mirrors that, so the two
 * sides agree without the frontend having to know the role list.
 */
export const FLEET_COST_PERMISSION = 'view-fleet-cost';

export default {
    computed: {
        /**
         * Draw the money columns/inputs? The API withholds those fields anyway,
         * so this is presentation only — it stops a planner being shown headers
         * over empty cells, or an input whose value they cannot load.
         */
        CanViewCost() {
            return this.$canDo(FLEET_COST_PERMISSION);
        },
    },
    methods: {
        // Canonical direction presentation — use these, never a new inline ternary.
        FleetDirection: fleetDirection,
        FleetDirectionLabel(direction) {
            return fleetDirection(direction).label;
        },
        FleetDirectionColor(direction) {
            return fleetDirection(direction).color;
        },
        FleetDirectionIcon(direction) {
            return fleetDirection(direction).icon;
        },
        FleetOffRouteText: fleetOffRouteText,
        FleetMovementColor(kind) {
            return FLEET_MOVEMENT_COLORS[kind] || '#5a6472';
        },
        FleetFormatNumber: fleetFormatNumber,
        FleetFormatDate: fleetFormatDate,
        FleetFormatDateTime: fleetFormatDateTime,
        FleetFormatTime: fleetFormatTime,
        FleetErrorText: extractFleetError,
        FleetTripTotals: tripTotals,
        FleetHasOffRouteVolume: hasOffRouteVolume,
        FleetTripStatusLabel(status) {
            return TRIP_STATUS_LABELS[status] || status || '...';
        },
        FleetTripStatusColor(status) {
            return TRIP_STATUS_COLORS[status] || '#666';
        },
        FleetStopStatusLabel(status) {
            return STOP_STATUS_LABELS[status] || status || '...';
        },
        FleetParcelStatusLabel(status) {
            return PARCEL_STATUS_LABELS[status] || status || '-';
        },
        FleetSizeClassLabel(sizeClass) {
            return SIZE_CLASS_LABELS[sizeClass] || sizeClass || '...';
        },
        FleetOwnershipLabel(ownership) {
            return OWNERSHIP_LABELS[ownership] || ownership || '...';
        },
        FleetStopTypeLabel(type) {
            return STOP_TYPE_LABELS[type] || type || '...';
        },
        // GPS integrity presentation — one vocabulary on every surface.
        FleetGpsFlagLabel(flag) {
            return fleetGpsFlag(flag).label;
        },
        FleetGpsFlagColor(flag) {
            return fleetGpsFlag(flag).color;
        },
        FleetGpsFlagSeverity(flag) {
            return fleetGpsFlag(flag).severity;
        },
        FleetGpsFlags: fleetGpsFlags,
        /** Joined labels for a title tooltip on the board's warning icon. */
        FleetGpsFlagsTitle(tripOrBlock) {
            return fleetGpsFlags(tripOrBlock).map((f) => fleetGpsFlag(f).label).join(' · ');
        },
        FleetFormatDuration: fleetFormatDuration,
        FleetGpsCoverageColor(pct) {
            const v = Number(pct) || 0;
            if (v >= 80) return '#2dcc70';
            if (v >= 50) return '#e8a10f';
            return '#e21312';
        },
    },
};
